import axios from "axios";
import tokenManager from "../../utils/tokenManager";

export const axiosLogin = axios.create({
  mode: "cors",
  baseURL: process.env.REACT_APP_LOGIN_API_URL
});

// Interceptor para adicionar token automaticamente em cada requisição
axiosLogin.interceptors.request.use(
  (config) => {
    // Lê o token atual do tokenManager antes de cada requisição
    const token = tokenManager.getToken();

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export const axiosInterceptor = (store, unauthorizedFunction) => {
  //Executa as funções antes de entregar a resposta
  // Mais sobre interceptors: https://axios-http.com/docs/interceptors
  axiosLogin.interceptors.response.use(
    function (response) {
      // Faz algo caso a resposta esteja nos 2xx
      return response;
    },
    function (error) {
      // Faz algo caso seja um erro

      // 401 é unauthorized
      // caso seja manda pra página de login
      if (error?.response?.status === 401) {
        unauthorizedFunction();
        store.setUser(null);
      }
      return Promise.reject(error);
    }
  );
};
